import { useMemo } from 'react';

import { useApplication } from '@eneco/common/application';

const useBusLabel = () => {
  const { language } = useApplication();

  const busLabel = useMemo(() => {
    return language === 'fr' ? 'boite' : 'bus';
  }, [language]);

  return busLabel;
};

export default useBusLabel;
